import * as React from 'react';
import styled from 'styled-components';

import { color } from 'styles/utils';

import TalkToUsCTA from 'components/TalkToUsCTA';
import Text from 'components/Text';
import Hero from 'components/Hero';

import reviewsGraphicLeft from 'images/editorial-graphics/reviews-graphics-left.svg';
import reviewsGraphicRight from 'images/editorial-graphics/reviews-graphics-right.svg';

const StyledBackground = styled.div`
  --width-gutter: calc((100% - min(46rem, 100%)) / 2);

  background-image: url(${reviewsGraphicLeft}), url(${reviewsGraphicRight});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left center, right center;
  pointer-events: none;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  mask-image: linear-gradient(
    to right,
    #000 calc(var(--width-gutter) - 18rem),
    #0002 calc(var(--width-gutter) - 2rem),
    #0000 calc(var(--width-gutter) + 6rem),
    #0000 calc(100% - var(--width-gutter) - 6rem),
    #0002 calc(100% - var(--width-gutter) + 2rem),
    #000 calc(100% - var(--width-gutter) + 18rem)
  );
`;

const StyledSection = styled.section`
  background-color: ${color('darkestTeal')};
  color: ${color('white')};
  position: relative;
  .hero-content {
    margin: 6rem 0 4rem 0;
  }
`;

export default function ReviewsHero() {
  return (
    <StyledSection>
      <Hero>
        <StyledBackground role="presentation" />
        <Text as="h1" variant="hero">
          Drive alignment with Reviews
        </Text>
        <Text variant="md">
          AI-powered, metrics-driven collaboration to drive impactful outcomes.
        </Text>
        <p>
          <TalkToUsCTA icon="arrow-up-right" />
        </p>
      </Hero>
    </StyledSection>
  );
}
